module.exports = __webpack_public_path__ + "static/media/project2.0ba09f38.jpg";